import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 全局禁用弹框点击遮罩（空白处）关闭，避免拖拽/拉伸过程中误触关闭
ElementUI.Dialog.props.closeOnClickModal.default = false

Vue.use(ElementUI)
